document.addEventListener('DOMContentLoaded', function () {
    const copyToClipboard = function (button, target) {
        navigator.clipboard.writeText(target.value);

        const popover = bootstrap.Popover.getInstance(button);
        popover.show();

        setTimeout(function () {
            popover.hide();
            button.blur();
        }, 2000);
    };

    // Check if elements exist before adding listeners
    const fileExchangeShareLink = document.getElementById('fileExchangeShareLink');
    const fileExchangeShareLinkButton = document.getElementById('fileExchangeShareLinkButton');
    if (fileExchangeShareLinkButton && fileExchangeShareLink) {
        fileExchangeShareLinkButton.addEventListener('click', function (event) {
            copyToClipboard(this, fileExchangeShareLink);
        });
    }

    const openWithShareLink = document.getElementById('openWithShareLink');
    const openWithShareLinkButton = document.getElementById('openWithShareLinkButton');
    if (openWithShareLinkButton && openWithShareLink) {
        openWithShareLinkButton.addEventListener('click', function (event) {
            copyToClipboard(this, openWithShareLink);
        });
    }

    const openWithSettingsLink = document.getElementById('openWithSettingsLink');
    const openWithSettingsLinkButton = document.getElementById('openWithSettingsLinkButton');
    if (openWithSettingsLinkButton && openWithSettingsLink) {
        openWithSettingsLinkButton.addEventListener('click', function (event) {
            copyToClipboard(this, openWithSettingsLink);
        });
    }

    const fileExchangeBadgeMarkdown = document.getElementById('fileExchangeBadgeMarkdown');
    const fileExchangeBadgeMarkdownButton = document.getElementById('fileExchangeBadgeMarkdownButton');
    if (fileExchangeBadgeMarkdownButton && fileExchangeBadgeMarkdown) {
        fileExchangeBadgeMarkdownButton.addEventListener('click', function (event) {
            copyToClipboard(this, fileExchangeBadgeMarkdown);
        });
    }

    const packageNameInput = document.getElementById('packageNameInput');
    const packageNameInputButton = document.getElementById('packageNameInputButton');
    if (packageNameInputButton && packageNameInput) {
        packageNameInputButton.addEventListener('click', function (event) {
            copyToClipboard(this, packageNameInput);
        });
    }

    document.querySelectorAll('[data-copy-target="mpminstall"]').forEach(function (button) {
        if (!bootstrap.Popover.getInstance(button)) {
            new bootstrap.Popover(button, {
                content: button.getAttribute('data-copied-text'),
                trigger: 'manual',
                placement: 'top',
                container: 'body',
                fallbackPlacements: []
            });
        }

        button.addEventListener('click', function (event) {
            event.stopPropagation();
            const input = this.closest('.input-group').querySelector('input');

            navigator.clipboard.writeText(input.value);
            const popover = bootstrap.Popover.getInstance(this);
            popover.show();
            setTimeout(function () {
                popover.hide();
            }, 2000);
        });
    });
});

// Fix for popover only showing on every second button click
// https://github.com/twbs/bootstrap/issues/16732
document.querySelectorAll('[data-bs-toggle="popover"]').forEach(function (element) {
    element.addEventListener('hidden.bs.popover', function () {
        const popoverInstance = bootstrap.Popover.getInstance(element);
        if (popoverInstance && popoverInstance._config && popoverInstance._config.inState) {
            popoverInstance._config.inState.click = false;
        }
    });
});
